import { render, staticRenderFns } from "./OrderTrackingTable.vue?vue&type=template&id=935f2cac&scoped=true&"
import script from "./OrderTrackingTable.vue?vue&type=script&lang=ts&"
export * from "./OrderTrackingTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrderTrackingTable.vue?vue&type=style&index=0&id=935f2cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935f2cac",
  null
  
)

export default component.exports